<!-- MARK: Upgrade Prices -->
<app-section sectionTitle="Upgrades Items Prices">
  <app-subsection subSectionTitle="Explanation">
    <p>
      These prices are used to calculate the profit from upgrade flips. You can type the prices you paid. Setup fee is calculated automatically when needed. Prices can be loaded from AODP (buy, sell or average prices) for the number of days
      and locations set below. Whenever prices are changed, they get updated in the flips list. The second input box is for the available amounts. If you set an amount, the flipper can hide flips for which you don't have enough resources.
      Whenever you consume a flip, the amount is reduced by the amount of resources used. You can save the prices and amounts you set to the database.">
    </p>
  </app-subsection>
  <app-section-subtitle>Actions</app-section-subtitle>
  <div style="margin-bottom: 8px">
    <button
      class="form-item-button"
      style="margin-top: 0px"
      mat-mini-fab
      (click)="flipperStateService.saveUpgradePricesAndAmountsToDb()"
      [disabled]="this.loadingBarService.getDisableSlowAPIButtons()"
      color="primary"
      matTooltip="Save Upgrade Prices and Amounts To the Database. This saves only the prices. Does NOT save any configs."
      aria-label="Save Upgrade Prices and Amounts To the Database"
    >
      <mat-icon>save</mat-icon>
    </button>
    <button
      class="form-item-button"
      style="margin-top: 0px"
      mat-mini-fab
      (click)="flipperStateService.loadUpgradeResourcesPricesAndAmountsFromDb()"
      [disabled]="this.loadingBarService.getDisableSlowAPIButtons()"
      color="primary"
      matTooltip="Load Your Upgrade Prices and Amounts from Database"
      aria-label="Load Your Upgrade Prices and Amounts from Database"
    >
      <mat-icon>cloud_download</mat-icon>
    </button>
    <button
      class="form-item-button"
      style="margin-top: 0px"
      mat-mini-fab
      (click)="flipperStateService.clickUpdateResourcePrices()"
      [disabled]="this.loadingBarService.getDisableSlowAPIButtons()"
      color="primary"
      matTooltip="Refresh Upgrade Prices from Albion Online Data Project. This REPLACES any typed prices."
      aria-label="Refresh Upgrade Prices from Albion Online Data Project"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  <app-section-subtitle>Prices</app-section-subtitle>
  <form [formGroup]="flipperStateService.flipperFormGroup" style="margin-bottom: 10px; display: flex; flex-wrap: wrap; align-items: start">
    @if (flipperStateService.upgradeResources(); as resources) {
      <div style="display: flex; flex-wrap: wrap; align-items: start">
        <mat-form-field>
          <mat-label>Buy Location</mat-label>
          <mat-select [formControl]="flipperStateService.flipperFormGroup.controls.resourceBuyLocationForm" multiple>
            @for (location of royalMarketLocations; track $index) {
              <mat-option [value]="location">{{ location.displayName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Buy From</mat-label>
          <mat-select [formControl]="flipperStateService.flipperFormGroup.controls.resourcesPriceType">
            @for (pt of priceTypes; track $index) {
              <mat-option [value]="pt">{{ pt.friendlyName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isAverageSelected) {
          <mat-form-field>
            <mat-label>Days for Average</mat-label>
            <input matInput [formControl]="flipperStateService.flipperFormGroup.controls.resourceAverageDays" type="number" step="1" min="3" max="30" />
          </mat-form-field>
        }
        <!-- linebreak -->
        <div style="flex-basis: 100%; height: 0"></div>
        @for (resource of flipperStateService.upgradeResources(); track $index) {
          @if ($index > 0) {
            @if (flipperStateService.upgradeResources()[$index - 1].item.resourceType !== resource.item.resourceType) {
              <!-- linebreak -->
              <div style="flex-basis: 100%; height: 0; margin-top: 5px"></div>
            }
          }
          <div style="display: flex; align-items: start">
            <app-item-image [item]="resource.item" [size]="50" />
            <div style="display: flex; flex-direction: column">
              <mat-label style="font-size: 11px; line-height: normal; padding-left: 5px">{{ resource.item.localizedName }}</mat-label>
              <div style="display: flex">
                <mat-form-field class="dense-form-field" matTooltip="Price (don't include setup fee)">
                  <input matInput [formControl]="flipperStateService.resourcesFormRecord.controls[resource.item.uniqueName]" style="font-size: 11px" type="number" step="1" min="0" />
                  <mat-hint style="font-size: 10px; display: flex">Price</mat-hint>
                </mat-form-field>
                <mat-form-field class="dense-form-field" matTooltip="Your Available amount">
                  <input matInput [formControl]="flipperStateService.availableAmountsFormRecord.controls[resource.item.uniqueName]" style="font-size: 11px" type="number" step="1" min="0" />
                  <mat-hint style="font-size: 10px; display: flex">Qty</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </form>
</app-section>
